<template><section><template>
<h3>Datetimepicker</h3>
<div class="bs-docs-section">
<div class="bs-example">
<n3-datetimepicker v-model="value" format="yyyy-MM-dd hh:mm:ss"></n3-datetimepicker>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-datetimepicker</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span> <span class="hljs-attr">format</span>=<span class="hljs-string">"yyyy-MM-dd hh:mm"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-datetimepicker</span>&gt;</span>
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">200px</code></td>
<td>width</td>
</tr>
<tr>
<td>format</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">yyyy-MM-dd hh:mm:ss</code></td>
<td>format</td>
</tr>
<tr>
<td>readonly</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>readonly</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>disabled</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>hide</td>
<td>hide</td>
<td>(currentValue)</td>
</tr>
<tr>
<td>change</td>
<td>change</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<p>PS: params of form components，look <a href="#n3FormDocs">Form</a> </p>
</div>
</template>

</section></template>

<script>

export default {
  methods: {
    hide (val) {
      console.log(val)
    }
  },
  data () {
    return {
      value: '2016-03-25 06:00:00',
      value1: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3DatetimepickerDocs.md?79fb9853